<div class="rounded-control p-4 my-4"
     [class.bg-amber-50]="type === 'warning'" [class.border-amber-400]="type === 'warning'"
     [class.bg-red-50]="type === 'error'" [class.border-red-400]="type === 'error'"
     [class.bg-green-50]="type === 'success'" [class.border-green-400]="type === 'success'"
     [class.border-l-4]="true">
  <div class="flex items-start">
    <div class="flex-shrink-0">
      <i class="fas fa-exclamation-triangle text-amber-400" *ngIf="type === 'warning'"></i>
      <i class="fas fa-times-circle text-red-400" *ngIf="type === 'error'"></i>
      <i class="fas fa-check-circle text-green-400" *ngIf="type === 'success'"></i>
    </div>
    <div class="ml-3 flex-1 min-w-0">
      <h3 class="text-sm font-medium"
          [class.text-amber-800]="type === 'warning'"
          [class.text-red-800]="type === 'error'"
          [class.text-green-800]="type === 'success'">{{title}}</h3>
      <div class="mt-2 text-sm"
           [class.text-amber-700]="type === 'warning'"
           [class.text-red-700]="type === 'error'"
           [class.text-green-700]="type === 'success'"
           [innerHtml]="message"></div>
    </div>
    <button *ngIf="dismissible" type="button" class="ml-3 flex-shrink-0 text-gray-400 hover:text-gray-600 transition"
            (click)="dismiss.emit()" aria-label="Dismiss">
      <i class="fas fa-times text-xs"></i>
    </button>
  </div>
</div>
